<div class="row button-container">
  <div class="col-2 custom-button">
    @if (enableFeatureCheckbox) {
      <div id="DcEmergency-enableFeature-text" class="rSet enable-alo-label">Enable feature
        <input type="checkbox"  class="primary-checkbox" id="enable-startup" [checked]="isEnableFeature"
          [(ngModel)]="ngModelval['DcEmergencyEnabled']" (change)="enableFeature($event.target.checked)" />
          <label for="enable-startup"><span id="DcEmergency-enableFeature-checkbox" class="extra-border-enablefeat" style="margin-left: 15px;" ></span></label>
        </div>
      }
    </div>
    <div class="col-8"></div>
    <div class="col-1"></div>
  </div>

  <div class="row slider-container" [ngClass]="{'isResetDisabled': isResetDisabled===true}">
    @if (isDimmingCheckbox) {
      <div id="DcEmergency-allowDimming-text" class="col-2 label signifyBookmd dim-margin mb-20 ml-24">Allow dimming
        <input type="checkbox"  class="primary-checkbox" id="enable-dimming" [checked]="isDimmingEnabled"
          [(ngModel)]="ngModelval['DcEmergencyDimmingEnabled']" [disabled]="isResetDisabled"
          (change)="dimmingEnabled($event.target.checked)" />
          <label for="enable-dimming" aria-label="Allow dimming"><span id="DcEmergency-allowDimming-checkbox" class="extra-border-enablefeat"></span></label>
        </div>
      }
      <div class="col-12"></div>

      <div id="DcEmergency-emergencyLevel-text" class="col-1 label signifyBookmd dim-margin">Emergency level</div>
      @if (quickConfigvalue) {
        <div class="col-2">
          <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
              <span class=" signifyBookmd minValue"> min {{floorValue}}</span>
            </div>
            <div class="col-2">
              <span class="signifyBookmd maxValue"> max {{ceilValue}}</span>
            </div>
          </div>
        </div>
      }

      @if (!quickConfigvalue) {
        <span id="DcEmergency-emergencyLevel-minText" class="signifyBookmd text-mindim  sliderMinValue col-1">{{floorValue}}</span>
      }
      @if (!quickConfigvalue) {
        <div class="col-6 curvePadding sliderCss" id="sliderClick"
          [ngClass]="{'isSliderClick': isSliderClick || isResetDisabled}">
          <ngx-slider type="normalType" [options]=valOptions [(value)]=sliderValue
            (userChangeEnd)="sliderValueChange($event.value)">
          </ngx-slider>
        </div>
      }
      @if (!quickConfigvalue) {
        <span id="DcEmergency-emergencyLevel-maxText" class="signifyBookmd text-mindim col-1 startUpMargin"
        [ngClass]="{'maxValueCss': quickConfigvalue===true}">{{ceilValue}}</span>
      }

      <div class="col-3 ml-9999 d-flex align-items-center" style="margin-top: -1em;">
        <input type="number" [(ngModel)]="textboxValue" (input)="valueChanged($event.target.value)"
          (keypress)="numberOnly($event)"
          [ngClass]="{'ml-76': quickConfigvalue===true,'myStyle': inputError===true, 'isResetDisabled': isResetDisabled===true, 'inputCssStandard': quickConfigvalue===true}"
          id="DcEmergency-emergencyLevel-InputValue"
          class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
          [disabled]="isResetDisabled" />
          <p id="DcEmergency-emergencyLevel-percentage" class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">
            (&#8776;{{calculatedPercentageVal}} %)
          </p>
        </div>
      </div>
